import { Injectable, inject } from '@angular/core';
import { ConnectionService } from '@services/connection-service';
import { TimeService } from '@services/time-service';
import { UserService } from '@services/user';
import { AllocatedRegimen } from '../../app/app-constant-types';
import { DIET_BANNER_PAGE, DietBannerPage } from '../../app/app.constants';

@Injectable({
  providedIn: 'root',
})
export class DietBannerService {
  private readonly conn = inject(ConnectionService);
  private readonly timeService = inject(TimeService);
  private readonly userService = inject(UserService);

  private static readonly HOME_EXPANDED_MAX_DAYS = 2;

  isCollapsed(regimen: AllocatedRegimen, page: DietBannerPage): boolean {
    if (page === DIET_BANNER_PAGE.INSTRUCTION) return false;
    const user = this.conn.getActingUser();
    if (!user || !this.userService.isPaidUser(user)) return true;
    const deliveredDate = regimen?.deliveredDate;
    if (!deliveredDate) return true;
    return this.timeService.differenceInDays(new Date(), new Date(deliveredDate)) > DietBannerService.HOME_EXPANDED_MAX_DAYS;
  }
}
